import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../configuration/colors'

const Wrapper = styled.div`
  position: relative;
  height: 18px;
  width: 4px;
  margin-left: 15px;
  @media screen and (max-width: 1200px) {
    height: 24px;
    width: 6px
  }
`

const ClickPadding = styled.div`
  position: absolute;
  left: -6px;
  top: -4px;
  padding: 4px 6px;
`

const ThreeDotMenuUl = styled.ul`
  display: flex;
  flex-direction: column;
  height: 18px;
  margin: 0;
  cursor: pointer;
  @media screen and (max-width: 1200px) {
    height: 24px;
  }
`

const ThreeDotMenuLi = styled.li`
  height: 4px;
  width: 4px;
  margin-bottom: 3px;
  background: ${props => props.isJourney ? '#999999' : colors.rock};
  border-radius: 4px;
  @media screen and (max-width: 1200px) {
    height: 6px;
    width: 6px;  
    border-radius: 6px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const ThreeDotMenu = ({ onHover, onClick, isJourney }) => (
  <Wrapper onClick={onClick}>
    <ClickPadding >
      <ThreeDotMenuUl onMouseOver={onHover}>
        <ThreeDotMenuLi isJourney={isJourney} />
        <ThreeDotMenuLi isJourney={isJourney} />
        <ThreeDotMenuLi isJourney={isJourney} />
      </ThreeDotMenuUl>
    </ClickPadding>
  </Wrapper>
)

ThreeDotMenu.propTypes = {
  onHover: PropTypes.func.isRequired
}

export default ThreeDotMenu
